import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import AppButtons from 'js/components/AppButtons/AppButtons'
import Button from 'js/components/Button/Button'
import { FromPrice } from 'js/components/PremiumButton/PremiumButton'

import useBreakpoints from 'js/hooks/useBreakpoints'
import { trackInstallClick } from 'js/analytics'
import { appButtonUrl, device } from 'js/device'
import {
  getPlanWithLowestMonthlyPrice,
  selectPricingConfig,
} from '../../store/pricingSlice'

type Props = {
  buttonText?: string
  color: 'green' | 'orange'
  orange
  useOfficialButton: boolean
  onDark?: boolean
  webSignup: boolean
  appStoreUrl?: string
  googlePlayUrl?: string
}

function DatoCTA({
  buttonText,
  color,
  useOfficialButton,
  webSignup,
  onDark,
  appStoreUrl,
  googlePlayUrl,
}: Props) {
  const pricing = useSelector(selectPricingConfig())
  const cheapestPlan = pricing
    ? getPlanWithLowestMonthlyPrice(pricing.products)
    : undefined
  const { XL } = useBreakpoints()

  const handleClick = () => {
    if (!webSignup) trackInstallClick(device)
  }

  if (useOfficialButton || !buttonText) {
    return (
      <div className="text-center">
        <AppButtons
          onDark={onDark}
          appStoreUrl={appStoreUrl}
          googlePlayUrl={googlePlayUrl}
        />
      </div>
    )
  }

  return (
    <div className="text-center">
      <Button
        big={XL}
        color={color === 'orange' ? 'premium' : 'green'}
        className="text-left"
        href={appButtonUrl}
        to={'/signup'}
        use={webSignup ? Link : 'a'}
        onClick={handleClick}
        shadow={onDark ? 'shadow-subtle' : undefined}
      >
        {buttonText}
      </Button>
      {pricing && pricing.discount && (
        <FromPrice
          cheapestPlan={cheapestPlan}
          discount={pricing.discount}
          discountType={pricing.discountType}
          currency={pricing.currency}
        />
      )}
    </div>
  )
}

export default DatoCTA
